import { getStorage, readStorageItem, removeStorageItem, writeStorageItem } from '@/utils/secure-storage';

const DEVICE_ID_KEY = 'winpay:h5:device-id';

function randomId() {
  if (window.crypto?.randomUUID) {
    return window.crypto.randomUUID();
  }

  const bytes = new Uint8Array(16);
  window.crypto?.getRandomValues(bytes);
  return Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
}

export function getDeviceId() {
  const storage = getStorage('local');
  const sessionStorage = getStorage('session');
  let saved = readStorageItem(DEVICE_ID_KEY, { storage });
  if (!saved) {
    saved = readStorageItem(DEVICE_ID_KEY, { storage: sessionStorage });
    if (saved) {
      writeStorageItem(DEVICE_ID_KEY, saved, { storage });
    }
  }
  removeStorageItem(DEVICE_ID_KEY, { storage: sessionStorage });
  if (saved) return saved;

  const id = `h5-${randomId()}`;
  writeStorageItem(DEVICE_ID_KEY, id, { storage });
  return id;
}

export function detectAppType() {
  const ua = navigator.userAgent || '';
  if (/android/i.test(ua)) {
    return 'android';
  }
  if (/iPhone|iPad|iPod/i.test(ua)) {
    return 'ios';
  }
  return 'h5';
}

export function isSafariBrowser() {
  const ua = navigator.userAgent || '';
  return /Safari/i.test(ua)
    && !/Chrome|CriOS|EdgiOS|Edg|OPR|Opera|Firefox|FxiOS|MicroMessenger/i.test(ua);
}

export function isIosSafariBrowser() {
  const ua = navigator.userAgent || '';
  return /iPhone|iPad|iPod/i.test(ua) && isSafariBrowser();
}
